import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
// application
import BlankPage from './pages/Blank';
// Vocation response reporting App
import SwitchPage from './pages/SwitchPage';
// Campaign reporting
import SwitchCampaignPage from './pages/SwitchCampaignPage';
// tuvocación source (internal REST API, firma HMAC)
import SwitchPageTuvocacion from './pages/SwitchPageTuvocacion';
import SwitchCampaignPageTuvocacion from './pages/SwitchCampaignPageTuvocacion';

function App() {
  return (
    <Router>
      <>
        <Route path='/' exact component={BlankPage} />
        <Route path='/r/:id' exact component={SwitchPage} />
        <Route path='/c/:id/:key' exact component={SwitchCampaignPage} />
        <Route path='/tuvocacion/r/:id' exact component={SwitchPageTuvocacion} />
        <Route
          path='/tuvocacion/c/:token'
          exact
          component={SwitchCampaignPageTuvocacion}
        />
      </>
    </Router>
  );
}

export default App;
